const BASE_URL = 'https://petapptechnigo.fly.dev'

export const API_URL = (slug) => `${BASE_URL}/${slug}`